import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import AppManager from "../../managers/AppManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import {
    DKLabel,
    DKButton,
    showToast,
    TOAST_TYPE,
    showLoader,
    DKIcons,
    removeLoader,
    showAlert
} from "deskera-ui-library";
import { useTranslation } from "react-i18next";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import PerformaceService from "../../services/PerformaceService";
import CreateGoal from "./CreateGoal";
import { getAppraisalCycleRowConfig, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import Utility from "../../utility/Utility";
import { fetchUsers, selectUsers } from "../../Redux/Slices/PayrollSlice";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../common/Popup";
import { TENANT, TenantService } from "../../managers/TenantManagerService";

import { COMPANY_DATE_FORMATS } from "../../constants/Constant";
import AppraisalManager from "./AppraisalManager";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

export default function AppraisalCycleList(props) {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };
    const [appraisalCycleAPIConfig,setAPIConfig] = useState({
        limit: 20,
        page: 0,
        search: '',
        sort: 'createdAt',
        sortDir: 'desc'
    })
    
    //State hooks
    const [gridData, setGridData] = useState(initialState);
    const [filterArray, setFilterArray] = useState([]);
    const [currentPage, setCurrentPage] = useState(appraisalCycleAPIConfig.page);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [goalPopup, setGoalPopup] = useState({
        visibility: false,
        data:null
    })
    const [applicableToPopup, setApplicableToPopup] = useState(null)
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const users = useSelector(selectUsers);

    let dateFormat = COMPANY_DATE_FORMATS.filter(c => c.label == TenantService.get(TENANT.DATE_FORMAT))
    dateFormat = dateFormat[0]?.value;

    useEffect(() => {
        setGridData({
            ...gridData,
            columnData:parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_APPRAISAL_CYCLES))),
            rowData:[]
        })
       
        getAppraisalCycle(appraisalCycleAPIConfig);
        getUsers()
        AppraisalManager.setAppraisalData(null);
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();
        return () => {
            // window.viewApplicableTo = null;
        }
    }, []);
    // API calls
    const getAppraisalCycle = (config) => {
        setAPIConfig(config);
        showLoader();
        PerformaceService.getAppraisalCycle().then(
            (res) => {
                removeLoader();
                if (res) {
                            setGridData({
                                ...gridData,
                                columnData:parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_APPRAISAL_CYCLES))),
                                rowData: getAppraisalCycleRowConfig(res)
                            })
                        }
            }, (error) => {
                removeLoader();
            }
        );
    }
    const getUsers = async () => {
        await dispatch(fetchUsers())
    }
    // grid function
    const onRowDelete = (data) => {
        console.log(data)
        let ids = [];
        if(data.rowData) {
            ids.push(data.rowData.id)
        } else if(Array.isArray(data)) {
            ids = data.map(d=>d.id)
        }
        if(!Utility.isEmpty(ids)) {
            showAlert(
                'Delete',
                'Are you sure you want to delete this record ?',
                [
                  {
                    title: "No",
                    className: "bg-gray1  border-m mt-r",
                    onClick:() => getAppraisalCycle(appraisalCycleAPIConfig)
                  },
                  {
                    title: "Yes",
                    onClick: () => deleteCycleAPI(ids),
                    className: "bg-app  text-white ml-r mt-r",
                  },
                ]
              );
        }
        
     }
     const deleteCycleAPI = (ids) => {
        showLoader('deleting record...');
        PerformaceService.deleteAppraisalCycle({ids:ids}).then(res=>{
            showToast('Record deleted successfully.', TOAST_TYPE.SUCCESS);
            
        },error=>{
            if(error && error.errorMessage) {
                showAlert('Error',error.errorMessage)
            }
        }).finally(()=>{
            getAppraisalCycle(appraisalCycleAPIConfig);
        })
     }
    const onRowEdit = (data) => {
        AppraisalManager.setAppraisalData(data.rowData.data);
        RouteManager.navigateToPage(PAGE_ROUTES.APPRAISAL_CYCLE_STEP)
        
    }
    const onContextCancel = () => {
        getAppraisalCycle({
            ...appraisalCycleAPIConfig
        })
     }
    const onCreateNew = () => { 
        RouteManager.navigateToPage(PAGE_ROUTES.APPRAISAL_CYCLE_STEP)
    }
    const onSort = () => { }
    const onSearch = (value) => {
        getAppraisalCycle({
            ...appraisalCycleAPIConfig,
            search: value
        });
    }
    const onColumnRowUpdate = () => { }
    const onFilter = () => { }
    const onRowAdd = (newRow) => { }
    const onClosePopup = (refresh) =>{
        if(refresh) {
            getAppraisalCycle(appraisalCycleAPIConfig);
        }
        setGoalPopup({
            ...goalPopup,
            visibility:false,
            data:null
        })
    }

    const getEmployeeName = (iamUserId) => {
        const userList = users?.users
        if(userList ) {
            const userObj = userList.find(u=>parseInt(u.iamUserId) === iamUserId);
            return `${userObj?.firstName} ${userObj?.lastName}`
        } else {
            return ''
        }
    }

    // UI renderer
    const getApplicableToPopup = () =>{
        let applicableToColumn = ``;
    if(!Utility.isEmpty(applicableToPopup?.applicability?.designation)) {
        applicableToColumn = `Designation: ${applicableToPopup?.applicability?.designation} `
    } else if(!Utility.isEmpty(applicableToPopup?.applicability?.teamId)) {
        applicableToColumn = `Team: ${applicableToPopup?.applicability?.teamName}`
    } else {
        applicableToColumn = (applicableToPopup?.applicability?.users?.length>1) ? 
        `${applicableToPopup.applicability?.users?.length} ${applicableToPopup?.applicability?.users?.length>1 ?"users":"user"}</text>`
        :``
    }
        return (
            <>
                <Popup className="" >
                    <div className="row justify-content-between">
                        <DKLabel className="fw-m fs-m" text={`Applicable To ${applicableToColumn}`}/>
                        <DKButton className="" icon={DKIcons.ic_close} title="" onClick={()=>setApplicableToPopup(null)}/>
                    </div>
                    <div className="">
                        <ol>
                        {applicableToPopup.applicability.users.map(iamUserId=>{
                            return <li className="p-v-xs">{getEmployeeName(iamUserId)}</li>
                        })}
                        </ol>
                    </div>
                </Popup>
            </>
        )
    }
    return (
        <>
            {/* <DKLabel className="fw-m fs-l" text="Goals" /> */}
            <div className="column parent-width flex-1">
                <div className="column  parent-width mb-s position-relative flex-1">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_APPRAISAL_CYCLES}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_APPRAISAL_CYCLES]}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        onRowDelete={onRowDelete}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        onCancelContext={() => {
                            onContextCancel();
                        }}
                        addButtonConfig={PermissionUtils.hasAccess(MODULE.PERFORMANCE_APPRAISAL_CYCLE, ACTION.CREATE) ? [{
                            title: "+ Create New Appraisal Cycle",
                            className: "bg-app text-white ml-s",
                            onClick: () => onCreateNew(),
                        }]:[]}
                        
                        gridData={gridData}
                        onSearch={onSearch}
                        onFilter={onFilter}
                        filter={filterArray}
                        onRowAdd={onRowAdd}
                        onPaginationClick={(requestedPageNumber) => {
                            getAppraisalCycle({
                                ...appraisalCycleAPIConfig,
                                page: requestedPageNumber
                            });
                        }}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        isActionEnabled={PermissionUtils.hasAccess(MODULE.PERFORMANCE_APPRAISAL_CYCLE, [ACTION.EDIT, ACTION.DELETE])}
                        contextMenu={PermissionUtils.hasAccess(MODULE.PERFORMANCE_APPRAISAL_CYCLE, ACTION.DELETE)}
                        isMenuVisible={PermissionUtils.hasAccess(MODULE.PERFORMANCE_APPRAISAL_CYCLE, ACTION.DELETE)}
                        allowRowEdit={false}
                        onSort={(data) => { onSort(data) }}
                        onRowUpdate={(data) => { onColumnRowUpdate(data) }}
                        onRowOpenBtnHidden={false}
                        showContextEdit={false}
                        dateFormat={dateFormat}
                        onColumnShift={(data)=>{onContextCancel()}}
                        module={MODULE.PERFORMANCE_APPRAISAL_CYCLE}
                    />
                </div>
            </div>
            {goalPopup.visibility && <CreateGoal data={goalPopup.data} onClose={(isRefresh)=>onClosePopup(isRefresh)}/>}
            {applicableToPopup && getApplicableToPopup()}
            
        </>
    )
}